import React, { Component, ChangeEvent, RefObject } from 'react'

import SelectOptionInterface from '../../interfaces/client/SelectOption'

import Icon from '../Icon'

import styles from './SelectField.module.scss'

interface SelectFieldPropsInterface {
  defaultValue: string
  inputName: string
  refName: string
  options: SelectOptionInterface[]

  isRequired: boolean
  isDisabled: boolean

  elementRef?: RefObject<HTMLSelectElement>
  onChange?: Function
  dataChanged?: boolean
  dataName?: string
  uploadedValue?: string
}

interface SelectFieldStateInterface {
  value: string
}

class SelectField extends Component<
  SelectFieldPropsInterface,
  SelectFieldStateInterface
> {
  state = {
    value: '',
  }

  componentDidMount() {
    if (this.props.defaultValue) {
      this.setState({ value: this.props.defaultValue })
    }
  }

  private readonly _handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    this.setState({ value: event.target.value })

    if (this.props.onChange) {
      this.props.onChange(event)
    }
  }

  render() {
    const {
      options,
      isRequired,
      inputName,
      refName,
      elementRef,
      isDisabled,
      defaultValue,
      dataChanged,
      dataName,
      uploadedValue,
    } = this.props

    return (
      <div className={styles['wrapper']}>
        <select
          className={styles['select']}
          onChange={this._handleChange}
          value={this.state.value}
          required={isRequired}
          name={inputName}
          ref={elementRef}
          disabled={isDisabled}
          data-element={refName}
          data-default-value={defaultValue}
          data-changed={dataChanged}
          data-name={dataName}
          data-uploadedvalue={uploadedValue}
        >
          {Boolean(options.length) &&
            options.map((option: SelectOptionInterface) => (
              <option
                value={option.value}
                key={`${option.value}${option.label}`}
                disabled={option.disabled}
              >
                {option.label}
              </option>
            ))}
        </select>

        <span className={styles['icon']}>
          <Icon name="down" />
        </span>
      </div>
    )
  }
}

export default SelectField
